import React from 'react';
import s from './index.module.css';

// TODO: Сделать компонент DescriptionPanel, вынести туда весь текст
const autorizedBenefits = [
    {
        icon: <div className={s.carIcon}></div>,
        description: 'Увидеть статус ваших заказов',
        key: 'статусы'
    },

    {
        icon: <div className={s.dialogIcon}></div>,
        description: 'Сохранить историю переписки с экспертами',
        key: 'общение'
    },
];

const Benefits = () => {
    return (
        <>
            <div className={s.benefitsDescription}><b>Войдите,
                чтобы увидеть</b> статус ваших заказов и <b>сохранить</b> историю переписки с экспертами</div>
        </>
    )
};

export default Benefits;